import {useSales} from "@/pages/workspaces/sales/SalesContext";
import Accordion from "@/components/Accordion";
import AccordionItem from "@/components/AccordionItem";
import {PhoneIcon} from "@heroicons/react/24/outline"
import {useTranslation} from "react-i18next";
import {AnimatePresence, motion} from "framer-motion";
import useCoreSiteContacts from "@/hooks/useCoreSiteContacts";
import Loader from "@/components/Loader";
import ContactListItem from "@/pages/workspaces/sales/ContactListItem";

export default function EducatorContacts() {
  const {t} = useTranslation();
  const {state} = useSales();
  const {clickedItem} = state;
  const siteId = clickedItem?.properties?.id;

  const {data: contactsData, isLoading, error} = useCoreSiteContacts(siteId);

  if (!clickedItem || clickedItem.cluster) return null;

  const count = contactsData?.total || 0;

  return (
    <AnimatePresence>
      <motion.div key={`site-contacts-${siteId}`}
      >
        <div className="text-base-content text-lg font-medium">{t('workspace.sales.educator_contacts')}</div>
        <Accordion>
          <AccordionItem
            key={`aci-${siteId}-contacts`}
            id={`aci-${siteId}-contacts`}
            title={t('contact', {count: count})}
            badge={count}
            icon={PhoneIcon}
          >
            {isLoading ? (
              <div className="text-sm test-base-content animate-pulse">
                <Loader/>
              </div>
            ) : error ? (
              <div className="text-sm text-error">
                {t('error')}: {error?.message}
              </div>
            ) : contactsData?.data?.length > 0 ? (
              <ul className="text-xs space-y-1 mt-1">
                {contactsData.data.map((contact) => (
                  <ContactListItem key={contact.id} contact={contact}/>
                ))}
              </ul>
            ) : (
              <div className="text-sm text-base-content italic">
                {t('workspace.sales.no_contacts')}
              </div>
            )}
          </AccordionItem>
        </Accordion>
      </motion.div>
    </AnimatePresence>
  )
}
